import { RichEditor } from '@/components/ui/richEditor';

import SlateReaderWidget from '@/components/forms/components/form/reader/widgets/slateReaderWidget';

import { isLockedWidget } from '@/components/forms/utils/links';

import { WidgetWriterProps } from '../widget.type';

type Props = {
  options: {
    withSubject: boolean;
    withMentions: boolean;
  };
} & WidgetWriterProps;

export const SlateWidget = ({
  id,
  value,
  formContext,
  placeholder,
  label,
  name,
  onChange,
  options = {
    withSubject: true,
    withMentions: false
  }
}: Props) => {
  // check if the widget is locked because of forms links
  const isLocked = isLockedWidget(id, formContext?.links);
  // if it is locked redirect to slate reader widget
  if (isLocked)
    return (
      <div className="border-border text-primary max-h-38 min-h-21 overflow-y-auto rounded-sm border px-3 py-2 opacity-50">
        <SlateReaderWidget label={label} value={value} name={name} />
      </div>
    );

  return (
    <RichEditor
      id={id}
      subjectPlaceholder={placeholder || 'Subject'}
      placeholder={placeholder || 'Enter your comment here.'}
      value={value}
      data-cy={`richText-${name}`}
      onChange={onChange}
      withSubject={options.withSubject}
      withMentions={options.withMentions}
      workflowContext={formContext?.workflowContext}
    />
  );
};
